import MechanismFieldParser from '../base/mechanism_field_parser'

import Procedure from '../../../models/mechanism/procedure'

export default class ProcedureParser extends MechanismFieldParser {
  constructor(context) {
    super(context, Procedure.PRESETS, { saveBefore: true })
  }

  parseDefinition (pattern, definition) {
    return this.add(new Procedure.ComplexProcedure(pattern, definition))
  }
}
